import { TableCard } from '../../../../components'
import { FuncionariosListHeader } from './components/header/FuncionariosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FuncionariosTable } from './table/FuncionariosTable'

const FuncionarioList = () => {
  return (
    <TableCard>
      <FuncionariosListHeader />
      <FuncionariosTable />
    </TableCard>
  )
}

export const FuncionarioListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <FuncionarioList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
